export const COMMENT_GENERATION_LANGUAGES = [
  {
    value: 'de',
    labelKey: 'german',
  },
  {
    value: 'en',
    labelKey: 'english',
  },
  {
    value: 'nl',
    labelKey: 'dutch',
  },
  {
    value: 'it',
    labelKey: 'italian',
  },
  {
    value: 'fr',
    labelKey: 'french',
  },
] as const;
